var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "function-editor" }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "IconButton",
            {
              attrs: {
                "on-click": function () {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_back_ios"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.createMode
                  ? _vm.$t("message.create")
                  : _vm.$t("message.edit")
              ) +
                " " +
                _vm._s(_vm.$t("message.aiFunction"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.$t("message.aiFunctionDesc"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.functionName")))]),
        _vm._v(" "),
        _c("div", { staticClass: "input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clone.name,
                expression: "clone.name",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.clone.name },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.clone, "name", $event.target.value)
                },
                _vm.handleNameInput,
              ],
            },
          }),
          _vm._v(" "),
          _vm.hasTurkishChars
            ? _c("div", { staticClass: "error-message" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.functionNameNoTurkish")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.functionDesc")))]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clone.description,
              expression: "clone.description",
            },
          ],
          domProps: { value: _vm.clone.description },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clone, "description", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "parameters" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("chatbotv2.parameters")))]),
            _vm._v(" "),
            _vm._l(_vm.clone.parameters, function (parameter, index) {
              return _c("FunctionParameter", {
                key: index,
                on: {
                  delete: function ($event) {
                    return _vm.clone.parameters.splice(index, 1)
                  },
                },
                model: {
                  value: _vm.clone.parameters[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.parameters, index, $$v)
                  },
                  expression: "clone.parameters[index]",
                },
              })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            attrs: { primary: "", ghost: "" },
            on: { click: _vm.addParameter },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.addParameter")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("a-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.saveFunction } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.save")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function () {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.cancel")))]),
              ]
            ),
            _vm._v(" "),
            !_vm.createMode
              ? _c(
                  "SupsisButton",
                  {
                    attrs: { danger: "" },
                    on: {
                      click: function () {
                        return _vm.$emit("deleted", _vm.clone)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.delete")))]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }